import { Spin } from "antd";

import styles from './RightAside.module.css'

const MasksLoader = () => {
  return (
    <div className={styles.spinnerContainer}>
      <Spin size="large" />
      <div className={styles.spinnerTextContainer}>
        <p className={`lg strong ${styles.spinnerTextTitle}`}>
          Carregant màscares
        </p>
        <p className={styles.spinnerTextInfo}>
          Estem carregant les màscares. Això pot trigar uns segons.
        </p>
      </div>
    </div>
  );
};
export default MasksLoader;
